export default {
  city        : /^\w{1,}[^]{0,300}$/,
  description : /^.{1,}[^]{0,2000}$/,
  email       : /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  firstName   : /^\w{1,}[^]{0,200}$/,
  fullName    : /^\w{1,}[^]{0,200}$/,
  lastName    : /^\w{1,}[^]{0,400}$/,
  line1       : /^\w{1,}[^]{0,1000}$/,
  name        : /^\w{1,}[^]{0,200}$/,
  password    : /^.{6,100}$/,
  phone       : /^(\d-?){8,30}$/,
  postal      : /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ][0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/,
  province    : /^(AB|BC|MB|NB|NL|NS|ON|PE|QC|SK|NT|NU|YT)$/,
  title       : /^.{1,}[^]{0,200}$/,
  number      : /^(\d+)?([.]?\d{0,2})?$/
};


// WEBPACK FOOTER //
// ./src/scripts/regex.js